'use client'

import { Heart } from 'lucide-react'
import ToggleIconButton from './ToggleIconButton'

interface AutomationFavoriteButtonProps {
  isFavorited: boolean
  onToggle: () => Promise<void> | void
  className?: string
  disabled?: boolean
}

export default function AutomationFavoriteButton({
  isFavorited,
  onToggle,
  className,
  disabled = false,
}: AutomationFavoriteButtonProps) {
  return (
    <ToggleIconButton
      isActive={isFavorited}
      onToggle={onToggle}
      icon={Heart}
      activeColor="fill-red-500 text-red-500"
      inactiveColor="text-gray-400 hover:text-red-400"
      rippleColor="bg-red-500/20"
      className={className}
      disabled={disabled}
    />
  )
}
